import DisablePrefetchLink from '@component/disablePrefetchLink'
import getEstimateRoute from '@plugin/searchRoute/modules/estimate'
import { estimateMap } from '@router'
import { joinStr } from '@utils'

export default function FindEstimateButton({
  data
}) {

  const estimateLink = (() => {
    const { suburbId, suburb, district } = data
    const estimateRoute = getEstimateRoute()

    if (suburbId && suburb && district) {
      estimateRoute.setSuburbs({
        label: joinStr([suburb, district], ', '),
        id: suburbId,
        level: 'suburb'
      })
    } else {
      estimateRoute.pushNewZealand()
    }
    const propertyId = data.propertyId
    if (propertyId) estimateRoute.houseId = propertyId
    return estimateMap(
      estimateRoute.toSlug(),
      data.lat && data.lng ? { center: joinStr([data.lng, data.lat], ','), zoom: 18 } : undefined
    )
  })()

  return (
    <DisablePrefetchLink href={estimateLink} target='_blank' className='button-primary-out w-full mt-10'>Find estimate</DisablePrefetchLink>
  )
}